var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0022 18.5V5.5C19.0022 4.87518 18.6821 4.5 18.1821 4C17.7986 3.60084 17.6451 3.42145 17.5426 3.18213C17.4726 3.01874 17.4177 2.81411 17.3686 2.49068C17.7264 2.43384 18 2.12387 18 1.75C18 1.33579 17.6642 1 17.25 1H6.75C6.33579 1 6 1.33579 6 1.75C6 2.12516 6.27546 2.43599 6.63516 2.49126C6.58617 2.81277 6.53138 3.01717 6.46151 3.18069C6.35884 3.421 6.20506 3.6015 5.82229 4C5.3222 4.5 5.0022 4.87519 5.0022 5.5V18.5C5.0022 18.7 5.0322 18.89 5.0922 19.06L6.0322 22.45C6.12173 22.79 6.4322 23.0022 6.76859 23H17.2341C17.5692 23 17.8796 22.7883 17.9733 22.4506L18.9143 19.0607C18.9712 18.8907 19.0022 18.7035 19.0022 18.5ZM6.7522 5.25C6.61413 5.25 6.5022 5.36193 6.5022 5.5V18.5C6.5022 18.6381 6.61413 18.75 6.7522 18.75H17.2522C17.3903 18.75 17.5022 18.6381 17.5022 18.5V5.5C17.5022 5.36193 17.3903 5.25 17.2522 5.25H6.7522ZM15.855 2.5H8.14884C8.08524 2.99218 7.999 3.39259 7.84936 3.75H16.1541C16.0046 3.39282 15.9185 2.99248 15.855 2.5ZM7.32261 21.5H16.6805L17.0275 20.25H6.97618L7.32261 21.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverage);
export default __webpack_public_path__ + "static/media/Beverage.41ba40084b034d1b5ed3ff9fd6d984d5.svg";
export { ForwardRef as ReactComponent };